import React from "react";
import { Navbar } from "react-bootstrap";
import Footer from "../../components/Footer";

const PrivacyPolicy = () => {
  return (
    <>
      <Navbar />
      <section className="privacy_sec">
        <div className="container">
          <div className="privacy_content">
            <h1>Privacy Policy</h1>
            <h5>Information Collection</h5>
            <p>
              We may collect personal information, such as names, contact
              information, and payment details, when voluntarily submitted by
              our visitors. This information is used solely for the purpose of
              fulfilling specific requests, unless permission is granted by the
              individual to use it for other purposes.
            </p>

            <h5>Information Usage</h5>
            <p>
              Any information collected will be used to fulfill orders, process
              payments, and provide tailored services to our users. We may also
              use collected information to improve our website, personalize user
              experience, or send periodic emails regarding updates, promotions,
              or other relevant information.
            </p>

            <h5>Data Protection</h5>
            <p>
              We implement a variety of security measures to maintain the safety
              of your personal information when you place an order or enter,
              submit, or access your personal information.
            </p>

            <h5>Third-Party Disclosure</h5>
            <p>
              We do not sell, trade, or otherwise transfer to outside parties
              your personally identifiable information.
            </p>

            <h5>Consent</h5>
            <p>By using our website, you consent to our privacy policy.</p>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;
